module.exports = [
    {
        "count": 83,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B001",
        "zip_code": 77510
    },
    {
        "count": 48,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B002",
        "zip_code": 77510
    },
    {
        "count": 49,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B003",
        "zip_code": 77510
    },
    {
        "count": 41,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B004",
        "zip_code": 77510
    },
    {
        "count": 45,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B005",
        "zip_code": 77510
    },
    {
        "count": 38,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B006",
        "zip_code": 77510
    },
    {
        "count": 30,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B007",
        "zip_code": 77510
    },
    {
        "count": 46,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B008",
        "zip_code": 77510
    },
    {
        "count": 39,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B009",
        "zip_code": 77510
    },
    {
        "count": 41,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B010",
        "zip_code": 77510
    },
    {
        "count": 47,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B011",
        "zip_code": 77510
    },
    {
        "count": 48,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B012",
        "zip_code": 77510
    },
    {
        "count": 42,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B013",
        "zip_code": 77510
    },
    {
        "count": 42,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B014",
        "zip_code": 77510
    },
    {
        "count": 29,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B015",
        "zip_code": 77510
    },
    {
        "count": 36,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B016",
        "zip_code": 77510
    },
    {
        "count": 27,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B017",
        "zip_code": 77510
    },
    {
        "count": 11,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B018",
        "zip_code": 77510
    },
    {
        "count": 25,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B019",
        "zip_code": 77510
    },
    {
        "count": 10,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B020",
        "zip_code": 77510
    },
    {
        "count": 37,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B021",
        "zip_code": 77510
    },
    {
        "count": 33,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B022",
        "zip_code": 77510
    },
    {
        "count": 21,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B023",
        "zip_code": 77510
    },
    {
        "count": 1,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "B050",
        "zip_code": 77510
    },
    {
        "count": 12,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R001",
        "zip_code": 77510
    },
    {
        "count": 38,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R002",
        "zip_code": 77510
    },
    {
        "count": 35,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R003",
        "zip_code": 77510
    },
    {
        "count": 14,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R004",
        "zip_code": 77510
    },
    {
        "count": 15,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R007",
        "zip_code": 77510
    },
    {
        "count": 83,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R008",
        "zip_code": 77510
    },
    {
        "count": 5,
        "doNotMail": 0,
        "expectedCount": 0,
        "lastProcessingTime": "",
        "loggerMessage": "",
        "melissaCount": 0,
        "noOfAttempts": 1,
        "reattemptsCount": 0,
        "route": "R010",
        "zip_code": 77510
    },
];